module.exports = "/lucky-balls/video/intro_de.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/video/intro_de.mp4
// module id = 882
// module chunks = 0